import {
  AutocompleteRenderInputParams,
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  TextFieldProps,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { AutoCompleteTextField } from '../AutoCompleteTextField';

interface EqlFieldValuesAutoCompleteInputProps {
  shouldAllowMultipleValues: boolean;
  toggleSelectAll: () => void;
  selectionMode: 'all' | 'selected';
  setSelectionMode: (value: 'all' | 'selected') => void;
  baseInputParams: AutocompleteRenderInputParams;
  fieldDisplayName: string;
  allSelected?: boolean;
  someSelected?: boolean;
  disableSelectAll?: boolean;
  inputVariant?: TextFieldProps['variant'];
}

export const EqlFieldValuesAutoCompleteInput = ({
  shouldAllowMultipleValues,
  selectionMode,
  setSelectionMode,
  toggleSelectAll,
  baseInputParams,
  fieldDisplayName,
  allSelected,
  someSelected,
  disableSelectAll = false,
  inputVariant = 'standard',
}: EqlFieldValuesAutoCompleteInputProps) => {
  return (
    <>
      <AutoCompleteTextField
        placeholder="Select a value"
        onKeyDown={(event) => {
          if (event.key === 'Backspace') {
            event.stopPropagation();
          }
        }}
        variant={inputVariant}
        {...baseInputParams}
      />
      {shouldAllowMultipleValues && (
        <Box>
          <Box
            sx={{
              px: 2,
              py: 1,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderBottom: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper',
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={2}
              alignItems="center"
            >
              <Typography color="text.secondary" variant="body2">
                Select from {fieldDisplayName}
              </Typography>
              <ToggleButtonGroup
                value={selectionMode}
                exclusive
                onChange={(_, value) => {
                  if (!value) {
                    return;
                  }

                  setSelectionMode(value);
                }}
                aria-label="Selection"
                size="small"
                color="primary"
              >
                <ToggleButton value="all">All Values</ToggleButton>
                <ToggleButton value="selected">Selected</ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Box>
          {selectionMode === 'all' && (
            <>
              <FormControlLabel
                label={
                  <Box
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSelectAll();
                    }}
                  >
                    {someSelected || allSelected
                      ? 'Deselect all'
                      : 'Select all'}
                  </Box>
                }
                control={
                  <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={toggleSelectAll}
                    disabled={disableSelectAll}
                    size="small"
                  />
                }
                sx={{
                  pl: 2,
                }}
              />
              <Divider light />
            </>
          )}
        </Box>
      )}
    </>
  );
};
